import React, { useEffect, useState, useCallback } from 'react';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
} from '../../../components/bootstrap/Modal';
import Button, { ButtonGroup } from '../../../components/bootstrap/Button';
import Badge from '../../../components/bootstrap/Badge';
import Card, { CardBody, CardHeader, CardTitle } from '../../../components/bootstrap/Card';
import { useTranslation } from 'react-i18next';
import { useMst } from '../../../models';
import DepartmentService from '../../../services/DepartmentService';
import UserService from '../../../services/UserService';
import FileExplorerTheme from '@nosferatu500/theme-file-explorer';
import SortableTree, { toggleExpandedForAll } from '@nosferatu500/react-sortable-tree';
import { setItem, removeItem } from '../../../lib/localstorage';
import { getLocalizedField } from 'helpers/localizedField';
import { getPersonDisplayName } from 'helpers/personNameI18n';


const MultiPersonSelectionModal = (props) => {
	const { t } = useTranslation();
	const tr = useCallback((name) => t(`userDashboard.${name}`), [t]);
	const { company } = useMst();
	const [departmentTree, setDepartmentTree] = useState([]);
	const [selectedUser, setSelectedUser] = useState([]);
	const [selectAll, setSelectAll] = useState(false);
	const [searchUsers, setSearchUsers] = useState([]); // 검색 유저
	
	const getDepartUser = async (departId) => {
 
		setSearchUsers([]);
		await UserService.listBy('department', departId, company.get.id).then((res) => {
 
			if (res.data) {
				setSearchUsers(res.data);
			}
		});
	};
	const loadDepartment = async () => {
		//await loadAllUsers();
		let response = await DepartmentService.getDepartementTree(company.get.id);
		
		if (response?.data) {
			setDepartmentTree(toggleExpandedForAll({ treeData: response.data, expanded: true }));
		}
	};
	useEffect(() => {
		setSelectedUser(props.selectedUser);
	}, [props.selectedUser]);

	useEffect(() => {
		if(props.isOpenFindUser){
			loadDepartment();
			setSearchUsers([])
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.isOpenFindUser]);

	useEffect(() => {
		let tmpUsers = [];
		const selectedUserIds = selectedUser.map(x=>x.userId)
		const searchUsersIds = searchUsers.map(x=>x.userId)
		if(selectAll){
			searchUsers.forEach((user) => {
				if (!selectedUserIds.includes(user.userId)) {
					tmpUsers.push(user);
				}
			});
			setSelectedUser([...selectedUser,...tmpUsers]);
		}else{
			setSelectedUser(selectedUser.filter(x=>!searchUsersIds.includes(x.userId)))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectAll]);

	// #242: [Revert] button Not change to [Apply all] button when re-open [Choose Receiver] popup
	useEffect(() => {
		if (props.isOpenFindUser && searchUsers.length === 0) {
			setSelectAll(false);
		}
	}, [props.isOpenFindUser, searchUsers]);

	// Change to [Revert] button after selecting all Team members
	// Change to [Apply all] button after unselecting all Applied employees that match with Team members
	useEffect(() => {
		if(!searchUsers?.length) return;
		const selectedUserIds = selectedUser.map(x => x.userId);
		const notSelectedUsersIds = searchUsers.filter(x => selectedUserIds.indexOf(x.userId) === -1);
		if(notSelectedUsersIds.length === 0) {
			setSelectAll(true);
		}
		else if(searchUsers.length === notSelectedUsersIds.length) {
			setSelectAll(false);
		}
	}, [searchUsers, selectedUser.length]);

	return (
		<Modal
			setIsOpen={props.setIsOpenFindUser}
			isOpen={props.isOpenFindUser}
			isStaticBackdrop={false}
			isScrollable={true}
			isCentered={true}
			size={'lg'}
			//fullScreen={true}
		>
			<ModalHeader /* setIsOpen={props.setIsOpenFindUser} */>
				<ModalTitle><p className='fs-3 fw-bold'>{props?.title}</p></ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div className='row w-100 h-100'>
					<div className='col-lg-5'>
						<Card className='w-100 h-100 ' shadow='none' borderSize={0} isScrollable>
							<CardHeader>
								<CardTitle>{t('companyAuthor.organizationChart')}</CardTitle>
							</CardHeader>
							<CardBody className='w-100'>
								<SortableTree
									style={{ minHeight: 500 }}
									treeData={departmentTree}
									onChange={setDepartmentTree}
									maxDepth={10}
									getNodeKey={({ node }) => node.id}
									canDrag={false}
									theme={FileExplorerTheme}
									generateNodeProps={(nodes) => {
 
										let nodeProps = {
											onClick: async (e) => {
												e.preventDefault();
												await getDepartUser(nodes.node.id);
											},
											title: (
												<ButtonGroup>
													<Button size='sm' color='light'>
														<span className='fw-light fs-6'>
															&nbsp;
															{getLocalizedField(nodes.node) || nodes.node.title}
														</span>
													</Button>
													<Button color='light' size='sm'>
														<Badge key={`tree-${nodes.node.id}`} color='dark'>
															{nodes.node.userCount}
														</Badge>
													</Button>
												</ButtonGroup>
											),
										};
										return nodeProps;
									}}
								/>
							</CardBody>
						</Card>
					</div>
					<div className='col-lg-7'>
						<div className='row d-flex flex-row h-100'>
							<div className='col-lg-7'>
								<Card className='w-100 h-100' shadow='none' borderSize={0} isScrollable={true}>
									<CardHeader>
										<CardTitle className='d-flex justify-content-between w-100 align-items-start'>
											{t('common.label.members')} {`(${searchUsers.length})`}
											<Button
												color='success'
												size='sm'
												onClick={() => {setSelectAll(!selectAll)}}>
												{selectAll ? tr('revert') : t('common.label.applyAll')}
											</Button>
										</CardTitle>
									</CardHeader>
									<CardBody
										className='d-flex flex-wrap align-items-start justify-content-start align-content-start p-1 w-100'
										isScrollable>
										<div className='d-flex flex-wrap align-content-center px-0 w-100'>
											{searchUsers.map((searchUser) => {
 
												return (
													<div key={`user-${searchUser.userId}`} className='py-1 w-100'>
														<div className='w-100 position-relative'>
															<Button
																color='light'
																size='sm'
																isDisable={
																	selectedUser?.findIndex((v) => v.userId === searchUser.userId) < 0
																		? false
																		: true
																}
																className='text-nowrap d-flex flex-column w-100'
																onClick={() => {
																	setSelectedUser([...selectedUser, searchUser]);
																}}>
																<span className='fs-6'>
																	{getPersonDisplayName(searchUser.user)}
																	{searchUser.rank && (
																		<span className='fw-light '>{` ${getLocalizedField(searchUser.rank)}`}</span>
																	)}
																</span>
																{searchUser.user && (
																	<span className='fw-light'>{` ${searchUser.user.email}`}</span>
																)}
															</Button>
															<Button
																icon={
																	selectedUser?.findIndex((v) => v.userId === searchUser.userId) < 0
																		? 'check'
																		: ''
																}
																size='sm'
																className='position-absolute top-0 end-0'
																onClick={() => {
																	setSelectedUser([...selectedUser, searchUser]);
																}}
															/>
														</div>
													</div>
												);
											})}
											{searchUsers.length === 0 && (
												<div className='fw-light'>
													<div>{tr('noMembersDepartment')}</div>
													<div>{tr('pleaseChooseOtherDept')}</div>
												</div>
											)}
										</div>
									</CardBody>
								</Card>
							</div>

							<div className='col-lg-5'>
								<Card shadow='none' borderSize={0} isScrollable className='h-100'>
									<CardHeader>
										<CardTitle>
											{tr('applied')} ({selectedUser ? selectedUser.length : 0})
										</CardTitle>
									</CardHeader>
									<CardBody
										className='d-flex flex-wrap align-items-start justify-content-start align-content-start w-100 p-1 pt-2'
										isScrollable>
										{selectedUser?.map((useUser, useUserIndex) => {
 
											//const useUser = allUsers.find(v=>v.user.id === u)
											return (
												<div key={`apply-user-${useUser.id}`} className='py-1 w-100'>
													<div className='w-100 position-relative'>
														<Button
															color='light'
															size='sm'
															className='text-nowrap d-flex flex-column w-100'
															onClick={() => {
																let tmp = [...selectedUser];
																tmp.splice(useUserIndex, 1);
																setSelectedUser(tmp);
															}}>
															<span className='fs-6'>
																{getPersonDisplayName(useUser.user)}
																{useUser.rank && (
																	<span className='fw-light '>{` ${getLocalizedField(useUser?.rank)}`}</span>
																)}
															</span>
															{/* {useUser.user && (
																			<span className='fw-light'>{` ${useUser.user.email}`}</span>
																		)} */}
															{<span className='fw-light'>{` ${useUser?.user?.email}`}</span>}
														</Button>
														<Button
															icon='close'
															size='sm'
															className='position-absolute top-0 end-0'
															onClick={() => {
																let tmp = [...selectedUser];
																tmp.splice(useUserIndex, 1);
																setSelectedUser(tmp);
															}}
														/>
													</div>
												</div>
											);
										})}

										{selectedUser && selectedUser.length === 0 && (
											<div className='fw-light'>
												<div>{tr('noAppliedMembers')}</div>
											</div>
										)}
									</CardBody>
								</Card>
							</div>
						</div>
					</div>
				</div>
			</ModalBody>
			<ModalFooter>
				<ButtonGroup>
					<Button
						type='button'
						color='info'
						onClick={() => {
							// removeItem('mailResult'); // Reset Result to Pending status
							props.setSelectedUser(selectedUser);
							// setItem('mailSelectedUser', JSON.stringify(selectedUser));
							if (props.setIsOpenSendMail)
								props.setIsOpenSendMail(true);
							// if(props.executeFunction)
							// 	props.executeFunction()
							props.setIsOpenFindUser(false);
						}}>
						{t('common.label.applied')}
					</Button>
					<Button
						type='button'
						color='light'
						onClick={() => {
							props.setIsOpenFindUser();
							setSelectedUser(props.selectedUser);
							if (props.setIsOpenSendMail)
								props.setIsOpenSendMail(true);
						}}>
						{t('common.label.close')}
					</Button>
				</ButtonGroup>
			</ModalFooter>
		</Modal>
	);
};
export default React.memo(MultiPersonSelectionModal);
